import { alpha, AppBar, Box, styled, Toolbar } from "@mui/material";
import { Breadcrumbs } from "components/Breadcrumbs";
import { StyledButton } from "components/StyledButton";
import { useAuthStatus } from "helpers/useAuthStatus";
import { useBreadcrumbs } from "helpers/useBreadcrumbs";
import { useRouteMatch } from "react-router-dom";
import { routes } from "routes";
import { NavBarAccountMenu } from "./NavBarAccountMenu";
import { NavBarLogoButton } from "./NavBarLogoButton";
import { useKeycloak } from "@react-keycloak/web";

const PREFIX = "NavBar";

const classes = {
    grow: `${PREFIX}-grow`,
    btn: `${PREFIX}-btn`,
};

const StyledAppBar = styled(AppBar)(({ theme }) => ({
    background: `linear-gradient(90deg, ${theme.palette.primary.main} 0%, ${alpha(
        theme.palette.primary.main,
        0.8,
    )} 88.02%)`,
    backgroundColor: "unset",
}));

const StyledStyledAppBar = styled(StyledAppBar)(() => ({
    [`& .${classes.grow}`]: {
        flexGrow: 1,
    },

    [`& .${classes.btn}`]: {
        marginLeft: "25px",
    },
}));

const StyledToolbar = styled(Toolbar)(() => ({
    root: {
        paddingLeft: 16,
        paddingRight: "16px",
        minHeight: 70,
    },
}));

export const NavBar = (): JSX.Element => {
    const { role, isLoading } = useAuthStatus();
    const { keycloak } = useKeycloak();
    const signInMatch = useRouteMatch(routes._.signIn.path);
    const { breadcrumbs } = useBreadcrumbs();

    const signInBtn = !signInMatch && (
        <StyledButton
            onClick={() => { void keycloak.login() }}
            color="inherit"
            className={classes.btn}
            primaryBackground
        >
            Sign in
        </StyledButton>
    );

    let rightSide: JSX.Element | null = null;
    if (role !== "unauthenticated") {
        rightSide = <NavBarAccountMenu />;
    } else if (!isLoading) {
        rightSide = <>{signInBtn}</>;
    }

    return (
        <StyledStyledAppBar position="fixed">
            <StyledToolbar>
                <Box display="flex" alignItems="center">
                    <NavBarLogoButton color={false} />
                    {role && <Breadcrumbs items={breadcrumbs} />}
                </Box>
                <div className={classes.grow} />
                {rightSide}
            </StyledToolbar>
        </StyledStyledAppBar>
    );
};
